import { ajaxRequest } from "../Ajax/ajax"
import { successToast } from "../utils"


export function loginFunction(){

    $(document).on("click", "#login-btn", function(e){
        e.preventDefault()

        const form = $("#login-form")

        const data = form.serializeArray()

        const url = form.attr('action')

        const success = function(data){
            successToast("Anmeldung erfolgreich")
            if (data.redirect_url){
                window.location = data.redirect_url
            } else {
                location.reload()
            }
        }

        ajaxRequest(url, success, data, $(this))
    })

}